import { ParsedQuery } from 'query-string';
import React, { FC, useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Switcher } from 'components/atoms/switcher';
import { useSearch } from 'hooks/use-search';
import { TemplateInsightSubTask, TemplateInsightViews } from './constant';

// TODO: add test case for this file
const getSubTab = (
  view: TemplateInsightViews,
  value: ParsedQuery<string>,
): string => {
  let subTab = TemplateInsightSubTask[view][0];

  const allowedSubTask = Object.values(TemplateInsightSubTask[view]);

  if (Array.isArray(value.subTab) && allowedSubTask.includes(value.subTab[0])) {
    [subTab] = value.subTab;
  }
  if (
    typeof value.subTab === 'string' &&
    allowedSubTask.includes(value.subTab)
  ) {
    subTab = value.subTab;
  }

  return subTab;
};

export const useSubTab = (
  view: TemplateInsightViews,
): [string, (subTab: string) => void] => {
  const [search, setSearch] = useSearch<{
    subTab: string;
  }>({
    from: (value) => {
      const subTab = getSubTab(view, value);

      return { ...value, subTab };
    },
    to: (value) => {
      return {
        subTab: value.subTab,
      };
    },
  });
  const onSwitch = useCallback(
    (subTab) => {
      setSearch({ subTab });
    },
    [setSearch],
  );

  return [search.subTab, onSwitch];
};

export const TemplateInsightSubTabSwitcher: FC<{
  view: TemplateInsightViews;
  onSwitch: (subTab: string) => void;
}> = ({ view, onSwitch }) => {
  const [selectedSubTab, setSubTab] = useSubTab(view);

  useEffect(() => {
    onSwitch(selectedSubTab);
  }, [onSwitch, selectedSubTab]);

  return (
    <Switcher
      value={selectedSubTab}
      onChange={(e) => {
        setSubTab(e.target.value);
      }}
      activeColor="black"
    >
      {TemplateInsightSubTask[view].map((subTab) => (
        <Switcher.Button key={subTab} value={subTab}>
          <FormattedMessage
            id={`reports.template_insight.tabs.${view}.sub-tab.${subTab}`}
          />
        </Switcher.Button>
      ))}
    </Switcher>
  );
};
